module.exports = __webpack_public_path__ + "static/tab_shape_bg-f0823274cf3b883d70592402ed4bfba0.png";